"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    "en-us": {
        "languageCode": "en-us",
        "stat": function stat(n, total) {
            return React.createElement(
                "div",
                null,
                n || "0",
                " of ",
                React.createElement(
                    "b",
                    null,
                    total
                ),
                " selected"
            );
        },
        "statNoSelection": function statNoSelection(total) {
            return React.createElement(
                "div",
                null,
                React.createElement(
                    "b",
                    null,
                    total
                ),
                " in total"
            );
        }
    },
    "zh-cn": {
        "languageCode": "zh-cn",
        "stat": function stat(n, total) {
            return React.createElement(
                "div",
                null,
                "\u5DF2\u7ECF\u9009\u62E9",
                n || "0",
                "\u9879\xA0/ \u5171",
                React.createElement(
                    "b",
                    null,
                    total
                ),
                "\u9879"
            );
        },
        "statNoSelection": function statNoSelection(total) {
            return React.createElement(
                "div",
                null,
                "\u5171",
                React.createElement(
                    "b",
                    null,
                    total
                ),
                "\u9879"
            );
        }
    },
    "zh-tw": {
        "languageCode": "zh-tw",
        "stat": function stat(n, total) {
            return React.createElement(
                "div",
                null,
                "\u5DF2\u7D93\u9078\u53D6",
                n || "0",
                "\u9805\xA0/ \u5171",
                React.createElement(
                    "b",
                    null,
                    total
                ),
                "\u9805"
            );
        },
        "statNoSelection": function statNoSelection(total) {
            return React.createElement(
                "div",
                null,
                "\u5171",
                React.createElement(
                    "b",
                    null,
                    total
                ),
                "\u9805"
            );
        }
    },
    "ru-ru": {
        "languageCode": "ru-ru",
        "stat": function stat(n, total) {
            return React.createElement(
                "div",
                null,
                "\u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0445 ",
                n || "0",
                " \u0438\u0437 ",
                React.createElement(
                    "b",
                    null,
                    total
                )
            );
        },
        "statNoSelection": function statNoSelection(total) {
            return React.createElement(
                "div",
                null,
                "\u0412\u0441\u0435\u0433\u043E ",
                React.createElement(
                    "b",
                    null,
                    total
                )
            );
        }
    }
};
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-table-area@0.0.19@@alicd/crui-table-area/lib/locale.js
// module id = 707
// module chunks = 0